import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "text-left text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_form = _resolveComponent("create-form")!
  const _component_assign_form = _resolveComponent("assign-form")!
  const _component_spot_assign_history_modal = _resolveComponent("spot-assign-history-modal")!
  const _component_sensor_sent_packets = _resolveComponent("sensor-sent-packets")!
  const _component_loader = _resolveComponent("loader")!
  const _component_table_action_header = _resolveComponent("table-action-header")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_dx_tooltip = _resolveComponent("dx-tooltip")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCreateModalOpened)
      ? (_openBlock(), _createBlock(_component_create_form, {
          key: 0,
          "is-create-modal-opened": _ctx.isCreateModalOpened,
          "refresh-data": _ctx.getSensors,
          onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCreateModalOpened = false))
        }, null, 8, ["is-create-modal-opened", "refresh-data"]))
      : _createCommentVNode("", true),
    (_ctx.isAssignModalOpened)
      ? (_openBlock(), _createBlock(_component_assign_form, {
          key: 1,
          "is-assign-modal-opened": _ctx.isAssignModalOpened,
          "refresh-data": _ctx.getSensors,
          sensor: _ctx.selectedSensor,
          onToggleModal: _ctx.toggleAssignModal,
          onOverrideComplete: _ctx.getSensors
        }, null, 8, ["is-assign-modal-opened", "refresh-data", "sensor", "onToggleModal", "onOverrideComplete"]))
      : _createCommentVNode("", true),
    (_ctx.isSpotAssignHistoryModalOpened)
      ? (_openBlock(), _createBlock(_component_spot_assign_history_modal, {
          key: 2,
          "is-spot-assign-history-modal-opened": _ctx.isSpotAssignHistoryModalOpened,
          "refresh-data": _ctx.getSensors,
          sensor: _ctx.selectedSensor,
          onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSpotAssignHistoryModalOpened = false))
        }, null, 8, ["is-spot-assign-history-modal-opened", "refresh-data", "sensor"]))
      : _createCommentVNode("", true),
    (_ctx.isSensorPacketsSentDisplay)
      ? (_openBlock(), _createBlock(_component_sensor_sent_packets, {
          key: 3,
          "is-sensor-packets-sent-displayed": _ctx.isSensorPacketsSentDisplay,
          mac: _ctx.selectedSensor.mac,
          title: `${_ctx.selectedSensor.space ?? ''} ${_ctx.selectedSensor.spot ?? ''} ${_ctx.selectedSensor.space || _ctx.selectedSensor.spot ? '-' : ''
      } ${_ctx.selectedSensor.mac}`,
          onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSensorPacketsSentDisplay = false)),
          fromProp: _ctx.from,
          toProp: _ctx.to
        }, null, 8, ["is-sensor-packets-sent-displayed", "mac", "title", "fromProp", "toProp"]))
      : _createCommentVNode("", true),
    _createVNode(_component_main_section, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_table_action_header, {
                icon: ['fas', 'add'],
                "permission-id": _ctx.permissions.CreateAssignment,
                "button-text": "Create",
                title: _ctx.$t('Sensors.Title'),
                onExecuteMethod: _ctx.toggleCreateModal
              }, null, 8, ["permission-id", "title", "onExecuteMethod"]),
              _createVNode(_component_custom_table, {
                "allow-auto-resize": true,
                "assign-column": true,
                "spot-assign-history": true,
                "is-action-list-not-displayed": true,
                "is-data-source-loading": _ctx.isDataSourceLoading,
                "render-summary": ['mac'],
                "show-per-page": 16,
                "table-data": _ctx.sensors,
                "table-headers": _ctx.tableHeaders,
                "table-height": "93%",
                onForceRefresh: _ctx.getSensors,
                onViewSensorPackets: _ctx.toggleSensorSentPackets,
                onAssignSensor: _ctx.toggleAssignModal,
                onSpotAssignHistory: _ctx.toggleSpotAssignHistoryModal,
                onOnCellPrepared: _ctx.onCellPrepared
              }, null, 8, ["is-data-source-loading", "table-data", "table-headers", "onForceRefresh", "onViewSensorPackets", "onAssignSensor", "onSpotAssignHistory", "onOnCellPrepared"]),
              _createVNode(_component_dx_tooltip, { ref: "tooltipRef" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("Sensors.Tooltip.PacketsFromFirmware")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.tooltipSensor.packetsSendCount), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t("Sensors.Tooltip.SavedPackets")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.tooltipSensor.packetSendSum), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 512)
            ]))
      ]),
      _: 1
    })
  ], 64))
}